import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { monthFromSlug, monthSlug } from "@/hooks/useHistoricalPrices";
import { permanentRedirect } from "@/lib/legacyRedirects";

/**
 * Gamla /historiska-elpriser/manad/<manad>-<ar> – permanent omdirigering (301)
 * till den nya månadssidan redan i serversvaret (tidigare i webbläsaren).
 */
export const Route = createFileRoute("/historiska-elpriser/manad/$monthYear")({
  head: () => seoHead("/historiska-elpriser/manad/$monthYear"),
  beforeLoad: ({ params }) => {
    const parts = (params.monthYear ?? "").toLowerCase().split("-");
    const month = monthFromSlug(parts[0]) ?? monthFromSlug(parts[1]);
    const year = parts.map(Number).find((n) => Number.isFinite(n) && n > 2000);
    if (month && year) permanentRedirect(`/elpriser/historik/elpriser-${year}/${monthSlug(month)}`);
    permanentRedirect("/elpriser/historik");
  },
});
